import { render, staticRenderFns } from "./brandFollow.vue?vue&type=template&id=81261fa8&scoped=true&"
import script from "./brandFollow.vue?vue&type=script&lang=js&"
export * from "./brandFollow.vue?vue&type=script&lang=js&"
import style0 from "./brandFollow.vue?vue&type=style&index=0&id=81261fa8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81261fa8",
  null
  
)

export default component.exports